import { useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_SAL1011_R01 } from "./Content_SAL1011_R01";
import { useSAL1011_R01Store } from "./Store_SAL1011_R01";
import { Table_SAL1011_R01 } from "./Table_SAL1011_R01";
import { Info_SAL1011_R01 } from "./Info_SAL1011_R01";
import { DetailTable_SAL1011_R01 } from "./DetailTable_SAL1011_R01";
import { SearchSection_SAL1011_R01 } from "./SearchSection_SAL1011_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL1011_R01DetailDto, SAL1011_R01HeaderDto } from "./Dto_SAL1011_R01";
import { showWarning } from "src/utils/toast/toastUtil";

export const Container_SAL1011_R01 = () => {
	const {
		allCount, initData, SAL1011_R01List, SAL1011_R01DetailList
	} = useSAL1011_R01Store();
	
	// 외부 의존성 주입 (SAL2020 패턴)
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	// 리사이저 설정
	const RESIZER = {
		code: 'SAL1011_R01',
		type: 'width',
		storageKey: 'SAL1011_R01-split-width',
		min: 5,
		max: 80,
		default: 35
	} as const;

	const gridRef = useRef<AgGridReact<SAL1011_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<SAL1011_R01DetailDto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'SAL1011_R01',
		type: 'height',
		storageKey: 'SAL1011_R01-info-split-height',
		min: 5,
		max: 80,
		default: 42
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultSAL1011_R01HeaderRow,
		defaultSAL1011_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_SAL1011_R01({
		gridRef,
		detailGridRef,
		tabList,
		setMessage,
		containerRef,
		isResizing,
	});

	useEffect(() => { 
		if (SAL1011_R01List.length === 0 && SAL1011_R01DetailList.length === 0) { handleCreateClick(); }
	}, [SAL1011_R01List, SAL1011_R01DetailList, handleCreateClick]);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleCreateClick}
				// onDeleteClick={notProductResult ? handleDeleteClick : () => { showWarning('생산실적결과가 있는 수주정보는 삭제가 불가능합니다.'); }}
				onDeleteClick={() => { showWarning('삭제기능을 지원하지 않습니다.'); }}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_SAL1011_R01 />
			
			{/* 좌: Table, 우: Info+DetailTable, 리사이저 */}
			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_SAL1011_R01 
						gridRef={gridRef}
						defaultSAL1011_R01HeaderRow={defaultSAL1011_R01HeaderRow()}
						handleCreateClick={handleCreateClick} 
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
					data-comment="리사이저"
				/>
				<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
					<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
						<Info_SAL1011_R01 
							defaultSAL1011_R01HeaderRow={defaultSAL1011_R01HeaderRow()}
						/>
					</div>
					{/* 리사이저 */}
					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
					/>
					<div style={{ height: `${100 - vSplitValue}%` }}>
						<DetailTable_SAL1011_R01 
							gridRef={detailGridRef} 
							defaultSAL1011_R01DetailRow={defaultSAL1011_R01DetailRow()}
						/>
					</div>
				</div>
			</div>
			<Message />
		</div>
	);
}; 